import React, { useState } from "react";
import { Phone, Menu, X } from "lucide-react";

const links = [
  { id: "accueil", label: "Accueil" },
  { id: "services", label: "Services" },
  { id: "pourquoi-moi", label: "Pourquoi moi" },
  { id: "villes", label: "Villes 974" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

const call = () => window.open("tel:+33745449641", "_self");

const MobileMenu = ({ go }) => (
  <div className="lg:hidden border-t border-amber-500/15 bg-zinc-950/95 px-4 pb-6 pt-2 fade-up" data-testid="mobile-menu">
    {links.map((l) => (
      <button key={l.id} onClick={() => go(l.id)} data-testid={`mobile-nav-${l.id}`}
        className="block w-full text-left py-3 text-zinc-200 border-b border-zinc-800/80 hover:text-amber-300">
        {l.label}
      </button>
    ))}
    <button onClick={call} data-testid="mobile-header-phone-btn"
      className="btn-shimmer mt-5 w-full text-zinc-950 font-semibold py-3 rounded-full flex items-center justify-center gap-2">
      <Phone className="w-4 h-4" /> +33 7 45 44 96 41
    </button>
  </div>
);

const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.href = `/#${id}`;
    setOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-zinc-950/85 backdrop-blur-xl border-b border-amber-500/15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 md:h-20">
          <a href="/" className="leading-tight" data-testid="header-logo">
            <span className="font-heading text-lg md:text-xl font-semibold gold-text block">Marabout Réunion</span>
            <span className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-zinc-400">Maître Diamma · 974</span>
          </a>

          <nav className="hidden lg:flex items-center gap-8">
            {links.map((l) => (
              <button key={l.id} onClick={() => go(l.id)} data-testid={`nav-${l.id}`}
                className="text-sm tracking-wide text-zinc-300 hover:text-amber-300 transition-colors duration-300">
                {l.label}
              </button>
            ))}
          </nav>

          <div className="hidden lg:flex">
            <button onClick={call} data-testid="header-phone-btn"
              className="btn-shimmer text-zinc-950 font-semibold text-sm px-5 py-2.5 rounded-full flex items-center gap-2 shadow-lg shadow-amber-500/20 hover:scale-105 transition-transform duration-300">
              <Phone className="w-4 h-4" /> +33 7 45 44 96 41
            </button>
          </div>

          <button className="lg:hidden text-amber-300 p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && <MobileMenu go={go} />}
    </header>
  );
};

export default Header;
